// extracted by mini-css-extract-plugin
module.exports = {"submitBtnWrap":"SubmitButton_submitBtnWrap__3-snX","submitButton":"SubmitButton_submitButton__3s5Yq"};